
import { defineComponent } from 'vue'
import { calculateFinancialSummary } from '@/api/advance';
import dayjs from 'dayjs';
const fristDay = dayjs().startOf('month').format('YYYY-MM-DD')
const lastDay = dayjs().endOf('month').format('YYYY-MM-DD')
export default defineComponent({
    props: {
        date: {
            type: Array,
            default() {
                return [fristDay, lastDay]
            }
        }
    },
    data() {
        return {
            details: {
                all: {
                    name: '已发金额（元）',
                    allMoney: 0,
                    paymentTotalMoney: 0,
                    advanceTotalMoney: 0,
                    className: 'fc-blue',
                    content: '所选时间段内发放薪资+预支薪资总计'
                },
                alr: {
                    name: '已领金额（元）',
                    alrPrice: 0,
                    paymentAlrMoney: 0,
                    advanceAlrMoney: 0,
                    className: 'fc-success',
                    content: '所选时间段内，员工实际领取的薪资总额（含发薪+预支，按发放时间统计）'
                },
                ait: {
                    name: '待领金额（元）',
                    aitPrice: 0,
                    paymentWaitMoney: 0,
                    advanceWaitMoney: 0,
                    className: '',
                    content: '所选时间段内，已发放但未领取的薪资总额（含发薪和预支，按发放时间统计）'
                },
                stop: {
                    name: '停发金额（元）',
                    stopPrice: 0,
                    paymentStopMoney: 0,
                    advanceStopMoney: 0,
                    className: 'fc-orange',
                    content: '所选时间段内，停止发放的金额总计（含发薪+预支，按发放时间统计）'
                }
            }
        }
    },
    watch: {
        date: {
            handler(newval) {
                if (newval) {
                    this.getData()
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
    },
    methods: {
        getData() {
            calculateFinancialSummary({
                startDate: (this as any).date[0],
                endDate: (this as any).date[1]
            }).then((res: any) => {
                for (const key in this.details) {
                    for (const key1 in (this as any).details[key]) {
                        if (typeof (this as any).details[key][key1] === 'number') {
                            (this as any).details[key][key1] = res[key][key1]
                        }
                    }
                }
                console.log(1111, this.details);
            })
        }
    }
})
